module.exports = __webpack_public_path__ + "static/media/release.f5832372.png";